import { useTranslation } from "react-i18next";

import { Form } from "react-bootstrap";

function AccidentInvoiceForm({ accidentInvoice, setAccidentInvoice }) {
  const { t } = useTranslation();
  return (
    <div className="invoice-page__modal_form_invoice-container">
      <Form.Group>
        <Form.Label>Noms et Prénoms de l'assuré: </Form.Label>
        <Form.Control
          label="text"
          value={accidentInvoice.name}
          onChange={(e) =>
            setAccidentInvoice({ ...accidentInvoice, name: e.target.value })
          }
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Date de naissance: </Form.Label>
        <Form.Control
          label="date de naissance"
          type="date"
          value={accidentInvoice.birthdate}
          onChange={(e) =>
            setAccidentInvoice({
              ...accidentInvoice,
              birthdate: e.target.value,
            })
          }
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Lieu de naissance:</Form.Label>
        <Form.Control
          label="Lieu de naissance"
          value={accidentInvoice.birth_place}
          onChange={(e) =>
            setAccidentInvoice({
              ...accidentInvoice,
              birth_place: e.target.value,
            })
          }
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Activité professionnelle exacte:</Form.Label>
        <Form.Control
          label="Activité professionnelle exacte"
          as="textarea"
          rows={5}
          columns={5}
          value={accidentInvoice.profession}
          onChange={(e) =>
            setAccidentInvoice({
              ...accidentInvoice,
              profession: e.target.value,
            })
          }
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Choix des Garanties :</Form.Label>
        <Form.Control
          label="Choix des Garanties"
          as="textarea"
          rows={8}
          columns={5}
          value={accidentInvoice.guarantee}
          onChange={(e) =>
            setAccidentInvoice({
              ...accidentInvoice,
              guarantee: e.target.value,
            })
          }
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Infirmité OUI ou NON</Form.Label>
        <br />
        <Form.Check
          inline
          label="Oui"
          name="invalid"
          type="radio"
          onChange={(e) =>
            setAccidentInvoice({
              ...accidentInvoice,
              invalid: e.target.value,
            })
          }
          value={true}
          id="oui"
        />
        <Form.Check
          inline
          label="Non"
          name="invalid"
          onChange={(e) =>
            setAccidentInvoice({
              ...accidentInvoice,
              invalid: e.target.value,
            })
          }
          value={false}
          type="radio"
          id="non"
        />
      </Form.Group>
    </div>
  );
}

export default AccidentInvoiceForm;
